<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row justify-content-center">
            <div class="col-lg-12" v-if="!loader">
              <div class="row align-items-center mb-4">
                <div class="col-md-12">
                  <h2 class="page-title mb-md-0 mb-3">
                    <a class="cursor-pointer" v-on:click="$router.go(-1)"
                      ><img
                        src="/images/back-arrow.svg"
                        width="20"
                        alt=""
                        class="me-2"
                    /></a>
                    My profile
                  </h2>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-lg-3 col-md-4 mb-4 position-relative">
                  <div
                    id="ProfileSlider"
                    class="carousel slide profile-sider"
                    data-bs-ride="carousel"
                    data-bs-interval="false">
                    <div class="carousel-inner rounded-l" v-if="images.length">
                      <div
                        class="carousel-item"
                        v-for="(data, index) in images"
                        :key="index"
                        :class="index == 0 ? 'active' : ' '">
                        <div
                          class="member-profile-photo cursor-pointer text-center"
                          data-bs-toggle="modal"
                          data-bs-target="#photosModal">
                          <a
                            v-on:click="showremoveImagePopup(data.uuid)"
                            type="button"
                            class="close text-danger">
                            <img src="/images/close-btn.png" width="18" />
                          </a>
                          <img
                            :src="data.image ? data.image : '/img/profile.svg'"
                            class="profile-pics1" />
                        </div>
                      </div>
                    </div>
                    <div
                      class="carousel-inner rounded-l text=center"
                      align="center"
                      v-if="images.length == 0">
                      <div class="carousel-item active">
                        <img src="/img/profile.svg" class="photos" />
                      </div>
                    </div>
                    <button
                      v-if="images.length"
                      class="carousel-control-prev"
                      type="button"
                      data-bs-target="#ProfileSlider"
                      data-bs-slide="prev">
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button
                      v-if="images.length"
                      class="carousel-control-next"
                      type="button"
                      data-bs-target="#ProfileSlider"
                      data-bs-slide="next">
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>
                  <div
                    class="text-center my-3 carousel-counter"
                    id="slide-counter">
                    <div class="num text-white"></div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-8 position-relative">
                  <h4 class="font-bold mb-3">
                    {{ detail.registration_no ? detail.registration_no : "-" }}
                  </h4>
                  <h4 class="font-bold text-uppercase mb-4">
                    {{ detail.first_name ? detail.first_name : "" }}
                    {{ detail.middle_name ? detail.middle_name : " " }}
                    {{ detail.last_name ? detail.last_name : "" }}
                  </h4>
                  <div class="mb-md-5 mb-4">
                    <button
                      type="button"
                      class="btn px-4 upload-img-merge-btn btn-outline-brand-1">
                      <i class="fa fa-cloud-upload me-2" aria-hidden="true"></i>
                      Upload Photo
                      <input
                        class="btn upload-img"
                        v-on:click="showImageModal()" />
                    </button>
                  </div>
                  <!-- <div
                    class="col-lg-6 position-md mb-md-0 mb-4"
                    style="bottom: 20px"
                  >
                    <p class="font-18 font-medium">
                      <span class="text-brand"
                        >{{ detail.profile_percentage }}%</span
                      >
                      Profile Completed
                    </p>
                    <div class="progress" style="height: 5px">
                      <div
                        class="progress-bar bg-brand"
                        role="progressbar"
                        :aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        :style="'width:' + detail.profile_percentage + '%'"
                      ></div>
                    </div>
                  </div> -->
                </div>
                <div class="col-lg-3 col-md-12">
                  <button
                    type="button"
                    class="btn btn-outline-brand-1 mb-3 w-100"
                    v-on:click="
                      $router.push('/profile-view/' + detail.uuid + '/SELF')
                    ">
                    <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                    Preview Profile
                  </button>
                  <button
                    v-on:click="downloadProfile()"
                    class="btn btn-brand-1 w-100 mb-3">
                    <i
                      class="fa fa-download font-20 me-2"
                      aria-hidden="true"></i>
                    Download Profile
                  </button>
                </div>
              </div>
              <hr />
              <div class="pt-2">
                <div class="mb-4">
                  <div
                    class="d-flex justify-content-between align-items-ceter mb-4">
                    <h3 class="font-bold font-18 mb-4">Personal Details</h3>
                    <router-link
                      to="/edit-profile"
                      class="nav-link text-brand font-medium btn btn-outline-brand-1"
                      ><i class="fa fa-pencil"></i>&nbsp; Edit Profile
                      &nbsp;</router-link
                    >
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <div class="row">
                        <div class="col-md-6">
                          <label>Registration No.</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{ detail.registration_no }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Gender</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{
                              detail.gender
                                ? detail.gender == "M"
                                  ? "MALE"
                                  : "FEMALE"
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Marital Status</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium" v-if="detail.marital_status">
                            {{ detail.marital_status.name }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Surname</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium pink-clr">
                            {{ detail.last_name }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Native Place</label>
                        </div>
                        <div class="col-md-6">
                          <div class="font-medium">
                            <div class="me-3">
                              <span class="font-regular">Gaon:</span>
                              {{
                                detail.native_place_goan
                                  ? detail.native_place_goan
                                  : "-"
                              }}
                            </div>
                            <div class="me-3">
                              <span class="font-regular">Taluka:</span>
                              {{
                                detail.native_place_taluka
                                  ? detail.native_place_taluka.name
                                  : "-"
                              }}
                            </div>
                            <div class="">
                              <span class="font-regular">Dist.:</span>
                              {{
                                detail.native_place_district
                                  ? detail.native_place_district.name
                                  : "-"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <label>Date of Birth</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{
                              detail.dob
                                ? $helperService.getNewFormatDate(detail.dob)
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <label>Height</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{
                              detail.height
                                ? $helperService.getHeight(detail.height) // + //   "-" + //   detail.height + //   "cm"
                                : "-"
                            }}
                            <!-- {{ detail.height ? detail.height : "-" }} -->
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Body Structure</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium" v-if="detail.body_structure">
                            {{ detail.body_structure.name }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Blood Group</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{ detail.blood_group ? detail.blood_group : "-" }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Skin Tone</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium" v-if="detail.scan_tone">
                            {{ detail.scan_tone.name }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Diet</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium" v-if="detail.diet">
                            {{ detail.diet.name }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="row">
                        <div class="col-md-6">
                          <label>Education</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{
                              detail.education_courses
                                ? detail.education_courses
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Occupational Details</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{
                              detail.occupation_details
                                ? detail.occupation_details
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <label>Annual Income (Lakh)</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{
                              detail.annual_income || detail.annual_income == 0
                                ? $helperService.kFormatter(
                                    detail.annual_income
                                  )
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <label>Work Location</label>
                        </div>
                        <div class="col-md-6">
                          <p
                            class="font-medium"
                            v-if="
                              detail.working_place_taluka ||
                              detail.working_place_goan
                            ">
                            {{
                              detail.working_place_taluka.name
                                ? detail.working_place_taluka.name
                                : ""
                            }}
                            {{
                              detail.working_place_taluka &&
                              detail.working_place_taluka.name &&
                              detail.working_place_goan
                                ? ", "
                                : ""
                            }}
                            {{
                              detail.working_place_goan
                                ? detail.working_place_goan
                                : ""
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Birth Time & Birth District</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{
                              detail.birth_time
                                ? $helperService.getFormatedTime(
                                    detail.birth_time
                                  )
                                : "-"
                            }}
                            {{
                              detail.birth_district
                                ? detail.birth_district.name
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <!-- <div class="row">
                        <div class="col-md-6">
                          <label>Gan</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium" v-if="detail.gan">
                            {{ detail.gan.name }}
                          </p>
                        </div>
                      </div> -->
                      <div class="row">
                        <div class="col-md-6">
                          <label>Mangal</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{
                              detail.is_mangal
                                ? detail.is_mangal == "Y"
                                  ? "Yes"
                                  : detail.is_mangal == "N"
                                  ? "No"
                                  : $helperService.getTitleCase(
                                      detail.is_mangal.replaceAll("_", " ")
                                    )
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Horoscope Details</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{
                              detail.raas && detail.raas.name
                                ? detail.raas.name + ","
                                : ""
                            }}
                            {{
                              detail.nakshatra && detail.nakshatra.name
                                ? detail.nakshatra.name + ","
                                : ""
                            }}
                            {{
                              detail.charan && detail.charan.name
                                ? detail.charan.name + ","
                                : ""
                            }}
                            {{
                              detail.nadi && detail.nadi.name
                                ? detail.nadi.name + ","
                                : "-"
                            }}

                            {{
                              detail.gan && detail.gan.name
                                ? detail.gan.name
                                : ""
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Devak</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{ detail.devak ? detail.devak : "-" }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Ready to move Abroad</label>
                        </div>
                        <div class="col-md-6">
                          <span class="font-medium">
                            {{
                              detail.ready_to_move_abrod &&
                              detail.ready_to_move_abrod == "Y"
                                ? "Yes"
                                : detail.ready_to_move_abrod == "N"
                                ? "No"
                                : detail.ready_to_move_abrod == "UNDECIDED"
                                ? "Undecided"
                                : detail.ready_to_move_abrod == "ALREADY_IN"
                                ? "Already In"
                                : "-"
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Other Information</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{ detail.other_info ? detail.other_info : "-" }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Login Mobile Number.</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{ detail.mobile_country_code }} {{ detail.mobile }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Login Email</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            {{ detail.email }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Family Details  -->
                <div class="mb-4">
                  <h3 class="font-bold font-18 mb-4">Family Details</h3>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="row">
                        <div class="col-md-6">
                          <label>Contact Full Name</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            <span class="me-3">
                              {{
                                detail.family_details
                                  ? detail.family_details.contact_full_name
                                  : "-"
                              }}</span
                            >
                          </p>
                        </div>
                      </div>
                      <!-- <div class="row">
                        <div class="col-md-6">
                          <label>Address</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            <span class="me-3">
                              {{
                                detail.family_details
                                  ? detail.family_details.address
                                  : "-"
                              }}</span
                            >
                          </p>
                        </div>
                      </div> -->

                      <div class="row">
                        <div class="col-md-6 mb-2">
                          <label>Address</label>
                        </div>
                        <div class="col-md-6" v-if="detail.family_details">
                          <div class="font-medium">
                            <div class="me-3">
                              <p class="font-medium">
                                <span class="me-3">
                                  {{
                                    detail.family_details
                                      ? detail.family_details.address
                                      : "-"
                                  }}</span
                                >
                              </p>
                            </div>
                            <div class="me-3">
                              <span class="font-regular">Gaon:</span>
                              {{
                                detail.family_details
                                  ? detail.family_details.goan
                                  : "-"
                              }}
                            </div>
                            <div class="me-3">
                              <span class="font-regular">Taluka:</span>
                              {{
                                detail.family_details &&
                                detail.family_details.taluka
                                  ? detail.family_details.taluka.name
                                  : "-"
                              }}
                            </div>
                            <div class="">
                              <span class="font-regular">Dist.:</span>
                              {{
                                detail.family_details &&
                                detail.family_details.district
                                  ? detail.family_details.district.name
                                  : "-"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Father Occupation</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            <span class="me-3">
                              {{
                                detail.family_details
                                  ? detail.family_details.father_occuption
                                  : "-"
                              }}</span
                            >
                            <span class="">
                              {{
                                detail.family_details
                                  ? detail.family_details.father_occuption_place
                                  : "-"
                              }}</span
                            >
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label>Mother Occupation</label>
                        </div>
                        <div class="col-md-6">
                          <p class="font-medium">
                            <span class="me-3"
                              >{{
                                detail.family_details
                                  ? detail.family_details.mother_occuption
                                  : "-"
                              }}
                            </span>
                            <span class="">
                              {{
                                detail.family_details
                                  ? detail.family_details.mother_occuption_place
                                  : "-"
                              }}</span
                            >
                          </p>
                        </div>
                      </div>
                      <div
                        class="row"
                        v-if="detail.family_details.family_members">
                        <div class="col-md-6 mb-3">
                          <label class="font-bold"
                            >Brother/Sister Details
                          </label>
                        </div>
                        <!-- <div class="col-md-6">
                          <p class="">
                            (If sister is married, mention surname only)
                          </p>
                        </div> -->
                      </div>
                    </div>
                    <div
                      class="col-lg-6"
                      v-if="detail.family_details.familty_phone_numbers">
                      <div
                        class="row"
                        v-for="(data, index) in detail.family_details
                          .familty_phone_numbers"
                        :key="index">
                        <div class="col-md-6">
                          <label class="">{{ data.type }}</label>
                        </div>
                        <div class="col-md-6 row">
                          <div class="col-7">
                            <p class="font-medium">{{ data.phone }}</p>
                          </div>
                          <div class="col-5">
                            <span
                              :style="
                                data.is_whatsapp == 'Y'
                                  ? 'opacity: 1;margin-top: 6px;'
                                  : 'opacity: 0.5;margin-top: 6px;'
                              "
                              class="h5 text-success mr-2 cursor-pointer"
                              ><i class="bx bxl-whatsapp"></i
                            ></span>
                            <span
                              :style="
                                data.is_phone == 'Y'
                                  ? 'opacity: 1;margin-top: 6px;'
                                  : 'opacity: 0.5;margin-top: 6px;'
                              "
                              class="h5 cursor-pointer"
                              ><i class="bx bxs-phone"></i
                            ></span>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="row">
                        <div class="col-md-6">
                          <label class="">Mother</label>
                        </div>
                        <div class="col-md-6 text-md-left">
                          <p class="font-medium">+91 9392929191</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="">Other</label>
                        </div>
                        <div class="col-md-6 text-md-left">
                          <p class="font-medium">+91 9392929191</p>
                        </div>
                      </div> -->
                      <div class="row">
                        <div class="col-md-6">
                          <label class="f">Email</label>
                        </div>
                        <div class="col-md-6 text-md-left">
                          <p class="font-medium">
                            {{
                              detail.family_details
                                ? detail.family_details.email
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <!-- <div class="row">
                        <div class="col-md-6">
                          <label class="">Contact Viewed on</label>
                        </div>
                        <div class="col-md-6 text-md-left">
                          <p class="font-medium">
                            {{
                              detail.opening_date
                                ? $helperService.getFormatDate(
                                    detail.opening_date
                                  )
                                : "-"
                            }}
                          </p>
                        </div>
                      </div> -->
                    </div>
                  </div>

                  <div class="table-wrap mb-3 table-responsive">
                    <table
                      class="table table-style-1 table-responsive table-striped table-hover text-center"
                      id="sorting_tbl">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Married?</th>
                          <th>Education</th>
                          <th>Occup.</th>
                          <th>Place</th>
                          <th>Birth Year</th>
                          <th>Hgt</th>
                          <th>Rel.</th>
                        </tr>
                      </thead>
                      <tbody v-if="detail.family_details.family_members">
                        <tr
                          v-for="(data, index) in detail.family_details
                            .family_members"
                          :key="index">
                          <td>{{ data.name ? data.name : "-" }}</td>
                          <td>
                            {{
                              data.is_married
                                ? data.is_married == "Y"
                                  ? "Yes"
                                  : "No"
                                : "-"
                            }}
                          </td>
                          <td>{{ data.education ? data.education : "-" }}</td>
                          <td>{{ data.occupation ? data.occupation : "-" }}</td>
                          <td>
                            {{ data.working_place ? data.working_place : "-" }}
                          </td>

                          <td>{{ data.birth_year ? data.birth_year : "-" }}</td>
                          <td>
                            {{
                              data.height
                                ? $helperService.getHeight(data.height) +
                                  "-" +
                                  data.height +
                                  "cm"
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              data.gender
                                ? data.gender == "M"
                                  ? "Bro"
                                  : "Sis"
                                : "-"
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-md-5">
                      <label class="font-bold font-18 mb-4"
                        >Mama’s Surname</label
                      >
                    </div>
                    <div class="col-lg-8 col-md-7">
                      <p class="font-medium">
                        <span class="me-4">
                          {{
                            detail.family_details
                              ? detail.family_details.mama_surname
                              : "-"
                          }}</span
                        >
                        <span class="me-4 font-regular">
                          Native Place:
                          <span class="font-medium">{{
                            detail.family_details
                              ? detail.family_details.mama_native_place
                              : "-"
                          }}</span></span
                        >
                        <span class="font-regular">
                          Taluka:
                          <span class="font-medium">{{
                            detail.family_details
                              ? detail.family_details.mama_taluka_place
                              : "-"
                          }}</span></span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="row" v-if="detail.family_details.relatives">
                    <div class="col-lg-4 col-md-5">
                      <label class="font-bold font-18 mb-4">Relatives </label>
                    </div>
                    <div class="col-lg-8 col-md-7">
                      <p
                        class="font-medium"
                        v-for="(data, index) in detail.family_details.relatives"
                        :key="index">
                        <span class="me-4" v-if="detail.relative.length > 0">
                          {{ data.surname ? data.surname : "-" }}
                          <span class="font-medium"
                            >- {{ data.goan ? data.goan : "-" }}</span
                          ></span
                        >
                        <!-- <span class="font-medium">
                          Jadhav
                          <span class="font-regular">- Junnar</span></span
                        > -->
                      </p>
                      <p class="font-medium" v-if="detail.relative.length == 0">
                        -
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-md-5">
                      <label class="font-bold font-18 mb-4">Properties </label>
                    </div>
                    <div
                      class="col-lg-8 col-md-7"
                      v-if="detail.user_properties">
                      <p
                        class="font-medium"
                        v-for="(data, index) in detail.user_properties"
                        :key="index">
                        <span class="me-4">
                          {{ data.details ? data.details : "-" }}
                          <span class="font-medium"
                            >- {{ data.place ? data.place : "-" }}</span
                          ></span
                        >
                      </p>
                      <p
                        class="font-medium"
                        v-if="detail.user_properties.length == 0">
                        -
                      </p>
                    </div>
                  </div>
                </div>
                <div class="" id="ScrollSec_3" v-if="detail.expectation">
                  <h3 class="font-bold font-18 mb-4">Expectations</h3>
                  <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label> Marital Status</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">
                        {{ marrital_status ? marrital_status : "-" }}
                      </p>
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Expected Body Structure</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">{{ body_structure }}</p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Expected Diet</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">{{ diet }}</p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Occupation</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">{{ occupation_type }}</p>
                    </div>
                  </div> -->

                  <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label> Birth Years</label>
                    </div>
                    <div class="col-lg-8 col-md-6" v-if="detail.expectation">
                      <p class="font-medium">
                        {{
                          detail.expectation.birth_year_from
                            ? detail.expectation.birth_year_from + " to "
                            : ""
                        }}

                        {{
                          detail.expectation.birth_year_to
                            ? detail.expectation.birth_year_to
                            : "-"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label> Height</label>
                    </div>
                    <div class="col-lg-8 col-md-6" v-if="detail.expectation">
                      <p class="font-medium">
                        {{
                          $helperService.getHeight(
                            detail.expectation.height_from
                          )
                            ? $helperService.getHeight(
                                detail.expectation.height_from
                              ) + "- " // detail.expectation.height_from + // " cm  to "
                            : ""
                        }}

                        {{
                          $helperService.getHeight(detail.expectation.height_to)
                            ? $helperService.getHeight(
                                detail.expectation.height_to
                              ) // "- " // detail.expectation.height_to + // " cm"
                            : "-"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-md-6 form-group">
                      <label>Patrika Matching</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">
                        {{
                          detail.expectation &&
                          detail.expectation.patrika_match == "Y"
                            ? "YES"
                            : detail.expectation &&
                              detail.expectation.patrika_match == "ALL"
                            ? "Flexible"
                            : detail.expectation &&
                              detail.expectation.patrika_match == "N"
                            ? "NO"
                            : "-"
                        }}
                      </p>
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6 form-group">
                      <label>Preferred Work Location</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">
                        {{ working_city_name ? working_city_name : "" }}
                        {{ working_country_name }}
                      </p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Preferred Native Places</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">
                        {{ native_district }}
                      </p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Family Residencial Taluka</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">
                        {{ family_residence }}
                      </p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Education Group</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">{{ education_group }}</p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Move to Abroad</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">
                        {{ move_to_abroad }}
                      </p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Per.</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">{{ personality }}</p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Echo Status</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">{{ echo_status }}</p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Relation</label>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <p class="font-medium">{{ relation }}</p>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-lg-4 col-md-6 form-group">
                      <label>Expected Education</label>
                    </div>
                    <div class="col-lg-8 col-md-6" v-if="detail.expectation">
                      <p class="font-medium">
                        {{
                          detail.expectation.expected_educations
                            ? detail.expectation.expected_educations
                            : "-"
                        }}
                      </p>
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col-lg-4 col-md-6 form-group">
                      <label>Expectations</label>
                    </div>
                    <div class="col-lg-8 col-md-6" v-if="detail.expectation">
                      <p class="font-medium">
                        {{
                          detail.expectation.occupation_other_expectations
                            ? detail.expectation.occupation_other_expectations
                            : "-"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ErrorComponent @retry="getDetail()" ref="errorComponent" />
          </div>
        </div>
      </div>
    </main>

    <!-- view contact -->

    <TextModal ref="contactModal">
      <div class="modal-header">
        <h5 class="modal-title">View Contact</h5>
        <button
          type="button"
          class="btn-close"
          v-on:click="$refs.contactModal.closeModal"></button>
      </div>
      <Form ref="viewProfileForm">
        <div class="modal-body">
          <p class="font-medium">{{ detail.registration_no }}</p>
          <div class="row">
            <div class="col-md-6">
              <label>Candidate Name: (Full name)</label>
            </div>
            <div class="col-md-6 text-md-left">
              <p class="font-medium">
                {{ detail.first_name }} {{ detail.middle_name }}
                {{ detail.last_name }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6"><label>Contact Full name</label></div>
            <div class="col-md-6 text-md-left" v-if="detail.family_details">
              <p class="font-medium">
                {{ detail.family_details.contact_full_name }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12"><p class="font-medium">Phone Number</p></div>
          </div>
          <div>
            <div
              class="row"
              v-for="(data, index) in detail?.familty_phone_numbers"
              :key="index">
              <div class="col-md-6">
                <label class="">{{ data.type }}</label>
              </div>
              <div class="col-md-6 text-md-left">
                <p class="font-medium">{{ data.phone }}</p>
              </div>
              <span
                v-if="data.is_whatsapp == 'Y'"
                class="h5 text-success mr-2 cursor-pointer"
                ><i class="bx bxl-whatsapp"></i
              ></span>
              <span
                v-if="data.is_phone == 'Y'"
                class="h5 text-success mr-2 cursor-pointer"
                ><i class="bx bxl-phone"></i
              ></span>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-md-6">
              <label class="">Email</label>
            </div>
            <div class="col-md-6 text-md-left" v-if="detail.family_details">
              <p class="font-medium">
                {{
                  detail.family_details.email
                    ? detail.family_details.email
                    : "-"
                }}
              </p>
            </div>
          </div> -->
          <div class="row">
            <div class="col-md-6">
              <label class="">Contact Viewed on</label>
            </div>
            <div class="col-md-6 text-md-left">
              <p class="font-medium">
                {{
                  detail.opening_date
                    ? $helperService.getFormatDate(detail.opening_date)
                    : "-"
                }}
              </p>
            </div>
          </div>
          <div class="text-center" v-on:click="sendEmail()">
            <a class="cursor-pointer" style="color: #bd1c9c"
              >SMS/Email these details to me</a
            >
          </div>
        </div>
      </Form>
    </TextModal>

    <TextModal ref="imageModal">
      <div class="spx-modal justify-content-center">
        <div class="spx-modal-body mx-auto">
          <div class="modal-header p-0">
            <div class="row">
              <h5 class="modal-title text-center">Upload Image</h5>
              <button
                type="button"
                class="btn-close"
                v-on:click="this.$refs.imageModal.closeModal()"></button>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12 col-sm-12">
                <div class="card border mb-0 radius-15">
                  <div class="card-body text-center">
                    <Form @submit="upload()">
                      <ImagePicker
                        :src="image"
                        :modelValue="image"
                        ref="ImagePicker" />
                      <div class="row">
                        <div class="col-lg-12 col-sm-12 text-center mt-2">
                          <button
                            id="save-button"
                            class="btn btn-lg btn-brand-1">
                            Save
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TextModal>
    <DeleteModal
      @remove="removeProfileImage(this.image_uuid)"
      ref="deleteModal" />
  </div>
</template>
<script>
import $ from "jquery";
import moment from "moment";
import ErrorComponent from "@/components/ErrorComponent";
import { Form } from "vee-validate";
import DeleteModal from "@/components/DeleteModal";
import ImagePicker from "@/components/ImagePicker.vue";
import TextModal from "@/components/TextModal.vue";
export default {
  name: "MyProfile",
  components: {
    ErrorComponent,
    Form,
    DeleteModal,
    ImagePicker,
    TextModal,
  },
  data() {
    return {
      loader: false,
      image_uuid: "",
      detail: {
        taluka: {},
        family_details: {
          family_members: [],
        },
        expectation: {},
      },
      images: [],
      file: "",
      marrital_status: "",
      // occupation_type: "",
      // personality: "",
      // relation: "",
      // echo_status: "",
      working_country_name: "",
      family_residence: "",
      working_country: "",
      native_district: "",
      // body_structure: "",
      working_city_name: "",
      // education_group: "",
      image_count: 0,
    };
  },
  mounted() {
    var totalItems = $(".carousel-item").length;
    var currentIndex = $(".carousel-item.active").index() + 1;
    $(".num").html("" + currentIndex + "/" + totalItems + "");

    $("#ProfileSlider").bind("slid", function () {
      currentIndex = $(".carousel-item.active").index() + 1;
      $(".num").html("" + currentIndex + "/" + totalItems + "");
    });
    if (window.location.pathname == "/my-profile") {
      window.scrollTo(0, 0);
    }
    this.getDetail();
    this.getImages();
  },
  methods: {
    downloadProfile() {
      var url = this.$api.getBaseUrl() + "get/biodata?uuid=" + this.detail.uuid;
      window.open(url);
    },
    showremoveImagePopup(uuid) {
      this.image_uuid = uuid;
      this.$refs.deleteModal.showModal(
        "Remove Image",
        "Are you sure you want to remove Image",
        {}
      );
    },

    removeProfileImage(uuid) {
      if (uuid) {
        this.$api
          .putAPI({
            _action: "/remove-image/" + uuid,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.$refs.deleteModal.closeModal();
            this.image_uuid = "";
            this.getDetail();
            this.getImages();
            document.getElementById("profile-image-2").click();
          })
          .catch(() => {});
      }
    },
    getDetail() {
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          // if (res.birth_time) {
          //   res.birth_time = moment(res.birth_time, "HH:mm:ss").format(
          //     "hh:mm A"
          //   );
          // }
          this.detail = res;
          if (
            this.detail.expectation &&
            this.detail.expectation.marital_status.length > 0
          ) {
            var array = [];
            for (var i in this.detail.expectation.marital_status) {
              array.push(this.detail.expectation.marital_status[i].name);
            }
            this.marrital_status = array.toString();
          }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.occupation_type.length > 0
          // ) {
          //   var array_1 = [];
          //   for (var j in this.detail.expectation.occupation_type) {
          //     array_1.push(
          //       ` ${this.detail.expectation.occupation_type[j].name}`
          //     );
          //   }
          //   this.occupation_type = array_1.toString();
          // }

          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.echo_status.length > 0
          // ) {
          //   var array_2 = [];
          //   for (var k in this.detail.expectation.echo_status) {
          //     array_2.push(` ${this.detail.expectation.echo_status[k].name}`);
          //   }
          //   this.echo_status = array_2.toString();
          // }

          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.relation.length > 0
          // ) {
          //   var array_3 = [];
          //   for (var l in this.detail.expectation.relation) {
          //     array_3.push(` ${this.detail.expectation.relation[l].name}`);
          //   }
          //   this.relation = array_3.toString();
          // }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.personality.length > 0
          // ) {
          //   var array_4 = [];
          //   for (var m in this.detail.expectation.personality) {
          //     array_4.push(` ${this.detail.expectation.personality[m].name}`);
          //   }
          //   this.personality = array_4.toString();
          // }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.education_group.length > 0
          // ) {
          //   var array_5 = [];
          //   for (var n in this.detail.expectation.education_group) {
          //     array_5.push(
          //       ` ${this.detail.expectation.education_group[n].name}`
          //     );
          //   }
          //   this.education_group = array_5.toString();
          // }
          res.opening_date = moment(this.detail.opening_date).format(
            "DD MMM YYYY "
          );
          if (
            this.detail.expectation &&
            this.detail.expectation.working_country.length > 0
          ) {
            var array_6 = [];
            for (var a in this.detail.expectation.working_country) {
              array_6.push(
                ` ${this.detail.expectation.working_country[a].name}`
              );
            }
            this.working_country_name = array_6.toString();
          }

          if (
            this.detail.expectation &&
            this.detail.expectation.working_city.length > 0
          ) {
            var array_7 = [];
            for (var b in this.detail.expectation.working_city) {
              array_7.push(` ${this.detail.expectation.working_city[b].name}`);
            }
            this.working_city_name = array_7.toString();
          }

          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.body_structure.length > 0
          // ) {
          //   var array_8 = [];
          //   for (var c in this.detail.expectation.body_structure) {
          //     array_8.push(
          //       ` ${this.detail.expectation.body_structure[c].name}`
          //     );
          //   }
          //   this.body_structure = array_8.toString();
          // }

          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.family_residence.length > 0
          // ) {
          //   var array_9 = [];
          //   for (var d in this.detail.expectation.family_residence) {
          //     array_9.push(
          //       ` ${this.detail.expectation.family_residence[d].name}`
          //     );
          //   }
          //   this.family_residence = array_9.toString();
          // }

          if (
            this.detail.expectation &&
            this.detail.expectation.native_district.length > 0
          ) {
            var array_10 = [];
            for (var e in this.detail.expectation.native_district) {
              array_10.push(
                ` ${this.detail.expectation.native_district[e].name}`
              );
            }
            this.native_district = array_10.toString();
          }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.diet.length > 0
          // ) {
          //   var array_11 = [];
          //   for (var f in this.detail.expectation.diet) {
          //     array_11.push(` ${this.detail.expectation.diet[f].name}`);
          //   }
          //   this.diet = array_11.toString();
          // }
          // if (
          //   this.detail.expectation &&
          //   this.detail.expectation.move_to_abroad.length > 0
          // ) {
          //   var array_12 = [];
          //   for (var g in this.detail.expectation.move_to_abroad) {
          //     array_12.push(
          //       ` ${this.detail.expectation.move_to_abroad[g].name}`
          //     );
          //   }
          //   this.move_to_abroad = array_12.toString();
          // }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.updateListLoader(false);
          }
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    showContactPopup() {
      this.$refs.contactModal.showModal();
    },
    getImages() {
      this.$api
        .getAPI({
          _action: "/user/images",
        })
        .then((res) => {
          this.images = res.list;
        })
        .catch(() => {});
    },
    upload() {
      var files = this.$refs.ImagePicker.file;
      if (
        files.type.toLowerCase() != "image/jpeg" &&
        files.type.toLowerCase() != "image/png" &&
        files.type.toLowerCase() != "image/svg+xml"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      const sizeInKB = files.size / 1024; // Convert to KB
      if (sizeInKB > 400) {
        alert("Photo size should not exceed 400 KB");
        return;
      }
      this.uploadImage(this.$refs.ImagePicker.file);
    },
    uploadImage(imageFile) {
      if (imageFile) {
        this.$api
          .uploadImageAPI({
            _action: "/user/add/photo",
            _key: "image",
            _file: imageFile,
          })
          .then((res) => {
            document.getElementById("profile-image").src =
              this.$refs.ImagePicker.image.src;
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getImages();
            this.getDetail();
            this.$refs.imageModal.closeModal();
          })
          .catch(() => {});
      } else {
        this.getImages();
        this.$refs.imageModal.closeModal();
      }
    },
    showImageModal() {
      if (this.images && this.images.length >= 2) {
        this.$notify({
          type: "error",
          text: "You cannot upload more then 2 Photos.",
        });
        return;
      }
      this.$refs.imageModal.showModal();
      this.$refs.ImagePicker.removeImage();
    },
    sendEmail() {
      this.$api
        .getAPI({
          _action: "/email-detail/" + this.detail.uuid,
        })
        .then(() => {
          this.$refs.contactModal.closeModal();
        })
        .catch(() => {});
    },
  },
};
</script>
